// extracted by mini-css-extract-plugin
export default {"countdown":"Countdown_countdown__qMEsG","icon":"Countdown_icon__36l-G"};